import { IEReservationIntervalDateGroupDto } from "modules/appointment/Dtos/IEReservationIntervalDateGroupDto";
import { IntervalElementStatus } from "modules/appointment/types/IntervalElementStatus";

import { DateObject } from "utils/DateObject";

export const createIntervalDateGroup = (
  date: string
): IEReservationIntervalDateGroupDto => {
  const intervalDate = DateObject(date);

  const intervals = hours(intervalDate.getDayOfMonth() + 10).map((hour) => {
    return {
      id: Math.floor(Math.random() * (100 + 1)) + 1,
      startDateTime: `${date} ${hour}`,
      status: IntervalElementStatus.Available,
      numberOfFreeSlots: 1
    };
  });

  return { date: date, intervals: intervals };
};

const hours = (minutes: number) => [
  `8:${minutes}`,
  `9:${minutes}`,
  `10:${minutes}`,
  `11:${minutes}`,
  `12:${minutes}`,
  `13:${minutes}`,
  `14:${minutes}`,
  `15:${minutes}`,
  `16:${minutes}`,
  `17:${minutes}`,
  `18:${minutes}`,
];
